// @flow
import { ConfigInfotoolsActionTypes } from './constants';

const INIT_STATE = {
    configInfotools: {},
    listaConfigInfotools: [],
    loading: false,
    error: false,
    formSubmited: false
};

type ConfigInfotoolsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { configInfotools?: {} | null, listaConfigInfotools?: [] | null, loading?: boolean, +value ?: boolean };

const ConfigInfotools = (state: State = INIT_STATE, action: ConfigInfotoolsAction): any => {
    // console.log(action);
    switch (action.type) {
        case ConfigInfotoolsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ConfigInfotoolsActionTypes.GET_CONFIG_INFOTOOLS: {
                    return {
                        ...state,
                        configInfotools: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ConfigInfotoolsActionTypes.LIST_CONFIGS_INFOTOOLS: {
                    return {
                        ...state,
                        listaConfigInfotools: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ConfigInfotoolsActionTypes.ADD_CONFIG_INFOTOOLS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ConfigInfotoolsActionTypes.UPDATE_CONFIG_INFOTOOLS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ConfigInfotoolsActionTypes.DELETE_CONFIG_INFOTOOLS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ConfigInfotoolsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ConfigInfotoolsActionTypes.GET_CONFIG_INFOTOOLS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        configInfotools: {},
                        loading: false,
                    };
                }
                case ConfigInfotoolsActionTypes.LIST_CONFIGS_INFOTOOLS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaConfigInfotools: [],
                        loading: false,
                    };
                }
                case ConfigInfotoolsActionTypes.ADD_CONFIG_INFOTOOLS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ConfigInfotoolsActionTypes.UPDATE_CONFIG_INFOTOOLS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ConfigInfotoolsActionTypes.DELETE_CONFIG_INFOTOOLS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ConfigInfotoolsActionTypes.GET_CONFIG_INFOTOOLS:
            return { ...state, error: false, loading: true };
        case ConfigInfotoolsActionTypes.LIST_CONFIGS_INFOTOOLS:
            return { ...state, error: false, loading: true };
        case ConfigInfotoolsActionTypes.ADD_CONFIG_INFOTOOLS:
            return { ...state, error: false, loading: true };
        case ConfigInfotoolsActionTypes.UPDATE_CONFIG_INFOTOOLS:
            return { ...state, error: false, loading: true };
        case ConfigInfotoolsActionTypes.DELETE_CONFIG_INFOTOOLS:
            return { ...state, error: false, loading: true };
        case ConfigInfotoolsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                configInfotools: {},
                listaConfigInfotools: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default ConfigInfotools;
